import axios from 'axios';

export default {
    namespaced: true,
    state: {
        listing: null,
        user: null,
        similarListings: null,
        loadingListingDetails: false
    },
    mutations: {
        loadListingDetails(state) {
            state.loadingListingDetails = true;
        },
        resetListingDetail(state) {
            state.listing = null;
            state.user = null;
            state.similar = null;
        },
        updateListingDetail(state, data) {
            state.loadingListingDetails = false;
            state.listing = data.listing;
            state.user = data.user;
        },
        updateSimilarListings(state, data) {
            state.similarListings = data;
        }
    },
    actions: {
        getListingDetail({ commit }, id) {
            commit('resetListingDetail');
            commit('loadListingDetails');
            axios
                .get('/listing/' + id)
                .then(result => {
                    commit('updateListingDetail', result.data.data);
                })
                .catch(console.error);

            axios
                .get('similar-listings?id=' + id)
                .then(result => {
                    commit('updateSimilarListings', result.data.data);
                })
                .catch(console.error);
        }
    }
};
